import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import { EMPLOYEE_TYPES_DICT } from "../../constants/employees";
import { HubDialogContent, HubHookFormWrapper } from "../../components";
import { usePostCreateAccount } from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

import CreateEmployeeFormSteps from "./CreateEmployeeFormSteps";

const CreateEmployeeContent = () => {
  const {
    mutate: postCreateAccount,
    isLoading,
    isSuccess,
  } = usePostCreateAccount();

  const { onClose } = useDialogContext();

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      name: formData.name,
      email: formData.email,
      dob: dayjs(formData.dob).toISOString(),
      doh: dayjs(formData.doh).toISOString(),
      phone: formData.phone,
      type: Number(formData.type || EMPLOYEE_TYPES_DICT.FULLTIME),
      locationId: Number(formData.locationId),
      departmentIds: formData.departmentIds?.map((d) => Number(d.id)),
      roleId: Number(formData.roleId),
      invite: formData.invite,
    };
    postCreateAccount(payload);
  };

  return (
    <HubDialogContent largePadding sx={{ overflow: "hidden" }}>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="35px" alignItems="center">
          <Stack alignItems="center">
            <Typography variant="h6">Create a New Employee</Typography>
            <Typography variant="caption">
              Use the fields below to add a new employee
            </Typography>
          </Stack>
          <CreateEmployeeFormSteps isLoading={isLoading} />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default CreateEmployeeContent;
